module.exports = __webpack_public_path__ + "img/simplification-buyer.9841619c.png";